/*
 Created by CHT 2020/9/18 9:03
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__NUMBER,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA, DEFAULT_VALUE__RELATE_DATA, FORM_ITEM__TABLE,
  FORM_ITEM__YES_NO
} from "../types"
import {defaultValueInit} from "../utils"

class YesNo extends BaseItem {

  constructor() {
    super()

    this.value = 0

    this.openText = '是'    // 打开时显示文字
    this.closeText = '否'   // 关闭是显示文字
    this.openColor = '#409eff'   // 打开时颜色
    this.closeColor = '#dcdfe6'  // 关闭时颜色
    this.showAsCheckbox = 0 //显示样式 是否为checkbox
    this.checkboxShowText = '检查框' // checkbox显示文字

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || YesNo._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

YesNo._title = '开关'
YesNo.type = FORM_ITEM__YES_NO
YesNo.use = true
YesNo.icon = 'iconfont icon-kaiguanclose'

YesNo.prototype.type = YesNo.type
YesNo.prototype.dataType = DATA_TYPE__NUMBER
YesNo.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, 0)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
YesNo.prototype.styleOpts = [
  {
    label: '开关样式',
    value: 0
  },
  {
    label: '检查框样式',
    value: 1
  }
]
YesNo.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  }
]
YesNo.prototype.getValue = function () {
  return this.value
}
YesNo.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || 0
}
YesNo.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.openText) this.openText = opts.openText
  if (opts.closeText) this.closeText = opts.closeText
  if (opts.openColor) this.openColor = opts.openColor
  if (opts.closeColor) this.closeColor = opts.closeColor
  if (opts.checkboxShowText) this.checkboxShowText = opts.checkboxShowText
  this.showAsCheckbox = opts.showAsCheckbox || 0
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
YesNo.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    openText: this.openText,
    closeText: this.closeText,
    openColor: this.openColor,
    closeColor: this.closeColor,
    defaultValue: this.defaultValue,
    checkboxShowText: this.checkboxShowText,
    showAsCheckbox: this.showAsCheckbox
  }
}
YesNo.prototype.valueToString = function (value) {
  value = value || this.value
  return value ? '是' : '否'
}
export default YesNo
